import bibtexParse from "bibtex-parse";
import { isUrl } from "../../tools";

function getReference(reference) {
  const id = Math.random(100000) * 100000;
  let bibText = "";
  try {
    bibText = bibtexParse.entries(reference); // try to parse object as bibText
  } catch (err) {
    bibText = bibtexParse.entries(
      "@article{ahu61,title={Invalid reference}, author={Please check the format}}"
    );
  }

  //const bibText = "";
  if (bibText[0]) {
    const link = bibText[0]?.DOI
      ? `https://doi.org/${bibText[0].DOI}`
      : bibText[0]?.URL ?? "undefined"; // add an URL to the doi
    return {
      ...bibText[0],
      id,
      link,
      format: "bibtext",
      reference,
    };
  }

  if (isUrl(reference))
    return { id, link: reference, format: "url", reference }; // is the refence a valide URL?

  return { id, link: "undefined", format: "text", reference };
}

export default function getDescription(itemExtra) {
  const description = itemExtra?.description?.description ?? "";
  const descriptionItems = itemExtra?.description?.descriptionItems ?? "";
  // references can be everything: a URL, some free text or even a rich bibTextObj
  const references =
    itemExtra?.description?.references?.map((reference) =>
      getReference(reference)
    ) ?? [];

  const tags =
    itemExtra?.description?.tags?.map((tag) => {
      const id = Math.random(100000) * 100000;
      return { id, label: tag };
    }) ?? [];

  const usefulFor =
    itemExtra?.description?.usefulFor?.map((purpose) => {
      const id = Math.random(100000) * 100000;
      return { id, label: purpose };
    }) ?? [];

  const licenseInfo = itemExtra?.description?.licenseInfo ?? "";

  return {
    description,
    descriptionItems,
    tags,
    usefulFor,
    references,
    licenseInfo,
  };
}
